import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import SalesTicker from "./SalesTicker";
import WhatsAppFAB from "./WhatsAppFAB";
import CompareBar from "./CompareBar";
import SocialProofToasts from "./SocialProofToasts";
import ExitIntentPopup from "./ExitIntentPopup";
import BreadcrumbSchema from "./BreadcrumbSchema";

const Layout = () => (
  <div className="flex min-h-screen flex-col">
    <BreadcrumbSchema />
    <Navbar />
    <main className="flex-1 pt-20">
      <SalesTicker variant="mine" />
      <SalesTicker variant="market" />
      <Outlet />
    </main>
    <Footer />
    <WhatsAppFAB />
    <CompareBar />
    <SocialProofToasts />
    <ExitIntentPopup />
  </div>
);

export default Layout;
